import { render, staticRenderFns } from "./UpdateMasterPoints.vue?vue&type=template&id=ea1ea2cc"
import script from "./UpdateMasterPoints.vue?vue&type=script&lang=js"
export * from "./UpdateMasterPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports